import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/store";
import { useLanguage } from "../../../components/LanguageContext";
import ToggleLang from "./ToggleLang";

const WebLogo = ({ src = null, alt = "logo", width = 120, height = 80, className = '', showLang = true }) => {

    const { web_logo } = useSelector((state: AppState) => state.webSettings);
    const { currentLanguage } = useLanguage();
    if (src === null) src = web_logo;

    return (
        <div className="d-flex flex-row align-items-center gap-3">
            <Link to={`/${currentLanguage}`} className={`logo ${className}`}>
                <img src={src} alt={alt} width={width} height={height} className="logo-img" />
            </Link>
            {showLang && <ToggleLang />}
        </div>
    );
};

export default WebLogo;